import { useEmbedStore } from '../embedStore';
import { useLeagueStore } from '../leagueStore';
import { getTenantConfig } from '../tenantConfig';
import { useTenantStore } from '../tenantStore';
import { useUserStore } from '../userStore';

export function useBaseStandardUi(isStandardFlexible: boolean): boolean {
  const isEmbed = useEmbedStore((state) => state.isEmbed);
  const tenantId = useTenantStore((state) => state.tenantId);
  const leagueId = useLeagueStore((state) => state.selectedLeague?.id);
  const isBpmSession = useUserStore((state) => state.is_bpm_session);
  const isTslhSession = useUserStore((state) => state.is_tslh_session);

  return isStandardFlexible && !isEmbed && tenantId === 'default'
    && leagueId !== getTenantConfig('arsenal').leagueId
    && leagueId !== getTenantConfig('tslh').leagueId
    && !isBpmSession && !isTslhSession;
}
